export const SESSION_REFETCH_INTERVAL_MINUTES = 10
